import { Stack, useTheme } from '@mui/material'
import {
  Container,
  DaysButton,
  InnerContainer,
} from './invoice-days-buttons.styles'
import {
  InvoiceDuration,
  InvoiceDurationType,
} from 'store/invoices/invoices.types'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { setDuration } from 'store/invoices/invoices.slice'

const InvoiceDaysButtons = () => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const duration = useSelector((state: RootState) => state.invoices.duration)

  const handleDurtion = (duration: InvoiceDurationType) => {
    dispatch(setDuration(duration))
  }

  return (
    <Container theme={theme}>
      <Stack spacing={2}>
        <InnerContainer direction="row" spacing={1}>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'All'}
            onClick={() => handleDurtion('All')}
          >
            {InvoiceDuration.All}
          </DaysButton>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'Under30'}
            onClick={() => handleDurtion('Under30')}
          >
            {InvoiceDuration.Under30}
          </DaysButton>
        </InnerContainer>

        <InnerContainer direction="row" spacing={1}>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'Over30'}
            onClick={() => handleDurtion('Over30')}
          >
            {InvoiceDuration.Over30}
          </DaysButton>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'Over45'}
            onClick={() => handleDurtion('Over45')}
          >
            {InvoiceDuration.Over45}
          </DaysButton>
        </InnerContainer>

        <InnerContainer direction="row" spacing={1}>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'Over60'}
            onClick={() => handleDurtion('Over60')}
          >
            {InvoiceDuration.Over60}
          </DaysButton>
          <DaysButton
            variant="outlined"
            theme={theme}
            selected={duration === 'Over90'}
            onClick={() => handleDurtion('Over90')}
          >
            {InvoiceDuration.Over90}
          </DaysButton>
        </InnerContainer>
      </Stack>
    </Container>
  )
}

export default InvoiceDaysButtons
